/** 假优惠领取收口三阶段动效配置（时长单位毫秒） */

/** 阶段一：弹窗渐缩关闭时长（与 Modal 关闭动画一致） */
const POPUP_COLLAPSE_MS = 300;
/** 阶段二：单张金币图片飞行时长 */
const COIN_FLY_MS = 350;
/** 阶段二：金币图片数量（多张依次飞行，更好展示轨迹） */
const COIN_FLY_COUNT = 3;
/** 阶段二：第 2 张金币图片的起飞延迟 */
const COIN_FLY_SECOND_DELAY_MS = 30;
/** 阶段二：第 3 张较第 2 张的额外起飞延迟 */
const COIN_FLY_THIRD_EXTRA_DELAY_MS = 80;
/** 阶段二：每张金币图片相对起飞的延迟 */
const COIN_FLY_DELAYS_MS = [0, COIN_FLY_SECOND_DELAY_MS, COIN_FLY_SECOND_DELAY_MS + COIN_FLY_THIRD_EXTRA_DELAY_MS];
/** 阶段二：金币初始边长（px） */
const COIN_FLY_SIZE = 120;
/** 阶段二：金币落点缩放比例 */
const COIN_FLY_END_SCALE = 0.3;
/** 阶段三：价格翻滚时长 */
const PRICE_ROLL_MS = 1500;

export const FAKE_DISCOUNT_ANIMATION = {
    popupCollapse: { durationMs: POPUP_COLLAPSE_MS },
    coinFly: {
        durationMs: COIN_FLY_MS,
        count: COIN_FLY_COUNT,
        delaysMs: COIN_FLY_DELAYS_MS,
        size: COIN_FLY_SIZE,
        endScale: COIN_FLY_END_SCALE,
    },
    priceRoll: {
        durationMs: PRICE_ROLL_MS,
        // 与金币飞行并行（边飞边滚）或等金币到位后再滚
        start: 'with-coin-fly' as 'with-coin-fly' | 'after-coin-fly',
    },
};
